import { render } from "./EventsCard.vue?vue&type=template&id=fdb66f62&scoped=true&ts=true"
import script from "./EventsCard.vue?vue&type=script&lang=ts"
export * from "./EventsCard.vue?vue&type=script&lang=ts"

import "./EventsCard.vue?vue&type=style&index=0&id=fdb66f62&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb66f62"]])

export default __exports__